export var TextFieldStyles = function (props) {
    var focused = props.focused, disabled = props.disabled, hasErrorMessage = props.hasErrorMessage, multiline = props.multiline, theme = props.theme;
    var palette = theme.palette, effects = theme.effects;
    return {
        fieldGroup: [
            {
                borderRadius: effects.roundedCorner2,
                borderColor: palette.neutralSecondaryAlt,
            },
            hasErrorMessage && [
                {
                    borderColor: palette.red,
                    selectors: {
                        '&:focus, &:hover': {
                            borderColor: palette.redDark,
                        },
                    },
                },
                focused && {
                    borderColor: palette.redDark,
                },
            ],
        ],
        field: [
            !disabled && {
                color: palette.neutralDark,
            },
            {
                padding: !multiline ? '0 8px' : '6px 8px',
                selectors: {
                    '::placeholder': [disabled && { color: palette.neutralTertiary }],
                    ':-ms-input-placeholder': [disabled && { color: palette.neutralTertiary }],
                },
            },
        ],
        wrapper: {
            borderColor: palette.neutralSecondaryAlt,
        },
        errorMessage: {
            color: palette.redDark,
        },
    };
};
//# sourceMappingURL=TextField.styles.js.map